// Shared by world.ts and levels.ts
export const K = 'cats';
export const DEG = Math.PI / 180;
/** Book sizes and density (the booklet is short and only reaches half as far when it topples) */
export const BOOK = { cats_book: { w: 26, h: 92, d: 0.0012 }, cats_booklet: { w: 20, h: 52, d: 0.0012 } };
export type BookType = keyof typeof BOOK;
